import React, {useEffect, useState} from "react";
import InputTitle from "./InputTitle";
import ButtonBase from "../buttons/ButtonBase";
import TextareaBase from "./TextareaBase";
import AddHomeworkForm from "./AddHomework";
import PageTitleSecondary from '../PageTitleSecondary'
import IconPlus from "../icons/IconPlus"

import { homeworkQuestions } from "../../../../http/homeworkAPI";


import {useForm, FormProvider} from 'react-hook-form'

const AddTopicForm = ({onSubmit, data, updateData, ...props}) => {

    const {handleSubmit, ...methods} = useForm({
        defaultValues: data || null
    })

    const [questionsList, setQuestionsList] = useState([])

    const [displayAddHWForm, setDisplayAddHWForm] = useState(false);

    const fetchQuestions = async () => {
        const {body: questionsData} = await homeworkQuestions(data.homework_id)
        setQuestionsList(questionsData)
    }

    useEffect(() => {
        if (data && data.homework_id) {
            fetchQuestions()
        }
    }, [data, displayAddHWForm])

    const addHomework = async () => {
        if (!data.homework_id) {
            await props.createHW()
            await fetchQuestions()
        }
        setDisplayAddHWForm(true)
    }


    return (
        <section className="pb-16 pt-16">
            <FormProvider {...methods}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="flex justify-between items-center mb-8">
                        <InputTitle 
                            name="title" 
                            placeholder="Введите название"
                            className="w-full"
                        />                    
                        <ButtonBase type="submit">Сохранить</ButtonBase>
                    </div>
                    <div>
                        <TextareaBase rows="5" name="description" placeholder="Комментарий" />
                    </div>
                </form>
            </FormProvider>

            {data && 
                <div className="mt-16">
                    <PageTitleSecondary>
                        Домашняя работа 
                        { data.homework_id && 
                            <span className="inline-block text-base ml-2 text-blue-gray/50">ID: {data.homework_id}</span>
                        }
                    </PageTitleSecondary>

                    <div className="mt-8">
                        {!displayAddHWForm && questionsList && questionsList.map((q, idx)=> <AddHomeworkForm key={q.question.id} data={q} idx={idx} hwId={data.homework_id} updateQuestions={fetchQuestions} />)}

                        {displayAddHWForm ? <AddHomeworkForm hwId={data.homework_id} closeForm={() => setDisplayAddHWForm(false)} updateQuestions={fetchQuestions} /> :
                            <div onClick={addHomework}>
                                <div className="bg-lavender-extra-light-30 border border-lavender-extra-light rounded-2xl min-h-[50px] basis-[278px] flex items-center justify-center cursor-pointer">
                                    <IconPlus />
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }
        </section>
    )
}

export default AddTopicForm